import React, { Component, PureComponent } from 'react';
import _ from 'lodash';
import cx from 'classnames';


import {
  Theme,
  createStyles,
  WithStyles,
  Typography,
  Grid,
  Button,
  withStyles,
} from '@material-ui/core';
import {
  dateService,
	MyPATMathField,
} from '../../../common';

import { fade } from '@material-ui/core/styles/colorManipulator';
import { Error } from '@material-ui/icons';

import contentService from '../../services/contentService';
import { ContentListFilterData } from '../../types/ContentFilterData';
import ContentData from '../../types/ContentData';
const styles = (theme: Theme) => createStyles({
  mb1x: {
    marginBottom: theme.spacing.unit,
  },

  questionBox: {
    // border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing.unit,
    '& textarea': {
      border: 0,
      padding: 0,
    },
    '& h6': {
      color: theme.palette.grey[400],
    },
    '& .suggested-box': {
      background: theme.palette.common.white,
      border: `1px solid ${theme.palette.grey[300]}`,
      borderRadius: theme.shape.borderRadius,
      padding: theme.spacing.unit,
      width: '80%',
      marginBottom: theme.spacing.unit,
      '&:last-child': {
        marginBottom: 0,
      }
    }
  },
  questionBoxError: {
    background: fade(theme.palette.error.light, 0.1),
    '& > div textarea': {
      background: 'transparent',
    },
  },
  errorText: {
    color: '#F21D1D',
    verticalAlign: 'middle',
    marginTop: '3px',
    '& svg': {
      verticalAlign: 'bottom'
    }
  }
});

interface QuestionTitleFieldProps extends WithStyles<typeof styles> {
  value: any,
  changeHandler: (e: any) => void,
  formData: any,
  name: string,
  inputId: string,
  type: string,
  subType: string,
  error: boolean,
  errorText: string,
}

interface QuestionTitleFieldState {
  showSuggestions: boolean,
  suggestions: ContentData[],
  mathEditor: any,
}

class QuestionTitleField extends PureComponent<QuestionTitleFieldProps, QuestionTitleFieldState> {
  constructor(props: QuestionTitleFieldProps) {
    super(props);
    this.state = {
      showSuggestions: false,
      suggestions: [],
      mathEditor:null,
    }
  }

  setMathInstance = (mathEditor:any) => {
    this.setState({ mathEditor })
    
  }
  
  handleInputChange = (e: any) => {
    // const { value } = e.target;
    // const { suggestions } = this.state;
    // const { type, subType, formData } = this.props;
    // if (value.length === 15 || (value.length > 15 && suggestions.length)) {
    //   // hit api call here and then handle hide and show
    //   let filter: ContentListFilterData = {};
    //   filter.searchText = value;
    //   filter.contentTypeCode = type;
    //   filter.contentSubTypeCode = subType;
    //   filter.content_Id = formData._id;
    //   contentService.suggestions(filter).then(contents => {
    //     this.setState({ suggestions: contents, showSuggestions: (contents.length > 0) });
    //   })
    // }
    return this.props.changeHandler(e);
  }

  render() {
    const {
      classes,
      value,
      error,
      errorText,
      formData,
      inputId,
      name,
    } = this.props;
    const { showSuggestions, suggestions } = this.state;
    
    return (
      <>
        <div className={cx(classes.questionBox, (error ? classes.questionBoxError : ""))}>
					<MyPATMathField
						variant='textarea'
						editorProps={{
							externalToolbarId: 'box',
							name: name,
							handleChange: this.handleInputChange,
							setInstance: this.setMathInstance,
							editorId: inputId,
							value,
              placeholder: 'Enter Question Text, or Paste Image'
						}}
					/>

          {showSuggestions && (
            <>
              <Typography variant="h6" color="textSecondary" gutterBottom>
                Similar question(s) in the library
              </Typography>

              {
                _.map(suggestions, content => (
                  <Grid container alignItems="center" justify="space-between" className="suggested-box">
                    <Grid item xs>
                      <Typography variant="body1" dangerouslySetInnerHTML={{ __html: content.title }}></Typography>
                    </Grid>
                    <Grid item xs="auto">
                      <Button variant="text" color="primary"
                        component="a"
                        target="_blank"
                        href={"/content/preview/" + content._id}
                      >
                        View
                      </Button>
                    </Grid>
                  </Grid>
                ))
              }
            </>
          )}
        </div>

        {
          error && (
            <Typography className={classes.errorText} variant="caption" color="error"><Error />{errorText}</Typography>
          )
        }

        {/*<Typography
          variant="caption"
          align="right"
          color="textSecondary"
          className={classes.mb1x}
        >
          Draft saved: {dateService.dateTime(formData.updatedAt)}
        </Typography>*/}
      </>
    )
  }
}

// @ts-ignore
export default withStyles(styles)(QuestionTitleField);